import React from "react";
import {Container} from "../Container";
import {IconCheckOutlined} from "../../assets";
import {Colors} from "../../colors";
import {StyledText} from "./StyledText";
import {Chip} from "../Chip";

interface LegalCollectionSubtitleProps {
  tagLabel: string;
}

export const LegalCollectionSubtitle = ({tagLabel}: LegalCollectionSubtitleProps) => {
  return (
    <Container row sx={{gap: "4px"}}>
      <IconCheckOutlined color={Colors.grey._1000} width={20} height={20} />
      <Chip label={tagLabel} variant_="error" size_="small" border sx={{marginLeft: "2px"}} />
      <StyledText value=" was " />
      <StyledText bold value="added" />
    </Container>
  );
};
